module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"here":"here","continue_message":"Not ready yet? Don’t worry, take some time to prepare and continue the registration {here} anytime."},"zh":{"here":"此处","continue_message":"文件或信息暂时没有准备好？没有关系，不要放弃。您可以先准备，然后随时在{here}续填。"}}')
  delete Component.options._Ctor
}
